<div class="modal" data-id="auf-modal" hidden>
  <div class="modal__backdrop" data-id="auf-backdrop"></div>

  <form class="modal__dialog" data-id="auf-form" role="dialog" aria-modal="true"
        aria-labelledby="auf-title" novalidate>
    <header class="modal__header">
      <h2 class="modal__title" id="auf-title" data-id="auf-title-text"><%= _lcs( 'Neuen Admin anlegen' ) %></h2>
      <button type="button" class="iconbtn modal__close" data-id="auf-close" aria-label="<%= _lcs( 'Schließen' ) %>">
        <i class="icon icon--x"></i>
      </button>
    </header>

    <div class="modal__body">
      <div class="field">
        <label class="field__label" for="auf-name"><%= _lcs( 'Name' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--user"></i></span>
          <input class="field__input" id="auf-name" name="name" type="text"
                 autocomplete="name" placeholder="<%= _lcs( 'Max Mustermann' ) %>" required
                 data-msg-required="<%= _lcs( 'Bitte gib einen Namen ein.' ) %>" />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="auf-email"><%= _lcs( 'E-Mail' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--mail"></i></span>
          <input class="field__input" id="auf-email" name="email" type="email"
                 inputmode="email" autocomplete="off" placeholder="name@belturo.com" required
                 data-msg-required="<%= _lcs( 'Bitte gib eine E-Mail-Adresse ein.' ) %>" />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="auf-password"><%= _lcs( 'Passwort' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--lock"></i></span>
          <input class="field__input" id="auf-password" name="password" type="password"
                 autocomplete="new-password" placeholder="<%= _lcs( 'Mindestens 6 Zeichen' ) %>" minlength="6" required
                 data-msg="<%= _lcs( 'Das Passwort muss mindestens 6 Zeichen lang sein.' ) %>" />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="auf-status"><%= _lcs( 'Status' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--heart-pulse"></i></span>
          <select class="field__input field__select" id="auf-status" name="status">
            <option value="ok" selected><%= _lcs( 'Aktiv' ) %></option>
            <option value="not_validated"><%= _lcs( 'Nicht verifiziert' ) %></option>
            <option value="blocked"><%= _lcs( 'Gesperrt' ) %></option>
            <option value="banned"><%= _lcs( 'Gebannt' ) %></option>
          </select>
        </div>
      </div>

      <p class="field__note">
        <i class="icon icon--shield-check"></i>
        <%= _lcs( 'Rolle:' ) %> <strong><%= _lcs( 'Administrator' ) %></strong> <%= _lcs( '(Plattform-Zugang)' ) %>
      </p>

      <p class="modal__error" data-id="auf-error" role="alert" hidden></p>
    </div>

    <footer class="modal__footer">
      <button type="button" class="btn btn--ghost btn--sm" data-id="auf-cancel"><%= _lcs( 'Abbrechen' ) %></button>
      <button type="submit" class="btn btn--primary btn--sm" data-id="auf-submit">
        <span data-id="auf-submit-label"><%= _lcs( 'Anlegen' ) %></span>
        <i class="icon icon--arrow-right"></i>
      </button>
    </footer>
  </form>
</div>
